import { render, staticRenderFns } from "./nueva-tarea.vue?vue&type=template&id=602ddbf6"
import script from "./nueva-tarea.vue?vue&type=script&lang=js"
export * from "./nueva-tarea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports